import React, {useCallback, useState} from "react";
import api from "../../api";
const initialData = [];

export default function useQuizSessionList() {
  const [data, setData] = useState(initialData);

  const load = useCallback(() => {
    return api.getQuizSessions().then(response => {
      setData(response.data || []);
    }).catch(() => {
      setData([]);
    })
  }, []);

  return {
    load,
    data
  }
}
